import { makeApiRequest } from '@/src/lib/api-request'
import { useMutation } from '@tanstack/react-query'

export const useSuggestChannelNamesMutation = () => {
  return useMutation({
    mutationKey: ['channel', 'suggest-names'],
    mutationFn: async (params: { channelName: string }) => {
      const response = await makeApiRequest({
        method: 'POST',
        fallbackError: 'Error while fetching channel name suggestions',
        isAuthenticated: false,
        url: '/Login_New/suggestChannelNames',
        data: { channelName: params.channelName },
        isV3Api: true,
      })

      return response.response as string[]
    },
  })
}
